export const ADMIN_EXPORT_LIST_TRANSLATION_NAMESPACE = "export-list";

export const ADMIN_EXPORT_LIST_TK = "ADMIN_EXPORT_LIST_TK";
